import { Form, Modal } from 'antd';
import styled from 'styled-components';

export const IconStyle = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;

export const OrgHeaderSecondary = styled.div`
  font-size: 12px;
  margin-bottom: 2px;
  font-weight: 500;
  line-height: 22px;
  color: rgba(0,0,0,.45);
`;

export const NewOrgTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
`;

export const ModalGlobalStyle = styled(Modal)`
  .ant-modal-header {
    background-color: rgba(239, 244, 247, 1);
  }
  .ant-modal-footer {
    background-color: rgba(239, 244, 247, 1);
  }
`;

export const FormInput = styled(Form.Item)`
  margin-bottom: 0px;
  .ant-form-item {
    margin-bottom: 0px;
  }
`;

export const InfoMessage = styled.div`
  margin-bottom: 0px;
  color: rgba(0, 0, 0, .45);
`;

export const CharCountSuffix = styled.span`
  font-size: 12px;
  color: #8c8c8c;
  margin-left: 8px;
`;

export const OptionalText = styled.span`
  color: rgba(0, 0, 0, .45);
`;
